import { createTheme } from "@material-ui/core/styles";

export let theme = createTheme({
	palette: {
		primary: {
			light: "#63ccff",
			main: "#009be5",
			dark: "#006db3",
		},
	},
	typography: {
		h5: {
			fontWeight: 500,
			fontSize: 26,
			letterSpacing: 0.5,
		},
	},
	shape: {
		borderRadius: 8,
	},
	props: {
		MuiTab: {
			disableRipple: true,
		},
	},
	mixins: {
		toolbar: {
			minHeight: 48,
		},
	},
});

theme = {
	...theme,
	overrides: {
		MuiDrawer: {
			paper: {
				backgroundColor: "#18202c",
			},
		},
		MuiButton: {
			label: {
				textTransform: "none",
			},
			contained: {
				boxShadow: "none",
				"&:active": {
					boxShadow: "none",
				},
			},
		},
		MuiTabs: {
			root: {
				marginLeft: theme.spacing(1),
			},
			indicator: {
				height: 3,
				borderTopLeftRadius: 3,
				borderTopRightRadius: 3,
				backgroundColor: theme.palette.common.white,
			},
		},
		MuiTab: {
			root: {
				textTransform: "none",
				margin: "0 16px",
				minWidth: 0,
				padding: 0,
				[theme.breakpoints.up("md")]: {
					padding: 0,
					minWidth: 0,
				},
			},
		},
		MuiIconButton: {
			root: {
				padding: theme.spacing(1),
			},
		},
		MuiTooltip: {
			tooltip: {
				borderRadius: 4,
			},
		},
		MuiDivider: {
			root: {
				backgroundColor: "#404854",
			},
		},
		MuiListItemText: {
			primary: {
				fontWeight: theme.typography.fontWeightMedium,
			},
		},
		MuiListItemIcon: {
			root: {
				color: "inherit",
				marginRight: 0,
				"& svg": {
					fontSize: 20,
				},
			},
		},
		MuiAvatar: {
			root: {
				width: 32,
				height: 32,
			},
		},
	},
};

export const drawerWidth = 256;

export const styles = {
	root: {
		display: "flex",
		minHeight: "100vh",
		maxWidth: 1980,
		marginLeft: "auto",
		marginRight: "auto",
	},
	drawer: {
		position: "relative",
		[theme.breakpoints.up("sm")]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	app: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
	},
	footer: {
		padding: theme.spacing(2),
		background: "#eaeff1",
	},
	container: {
		maxWidth: 1664,
		marginRight: "auto",
		marginLeft: "auto",
	},
	navigator: {
		"@media(min-width: 1921px)": {
			position: "absolute",
			minHeight: "100vh",
		},
	},
};
